import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from './notification.service';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] flex flex-col gap-2">
      @for (notification of notificationService.notifications$ | async; track notification.id) {
        <div
          class="px-4 py-3 rounded-lg shadow-lg text-sm font-medium min-w-[300px] text-center"
          [class.bg-primary-100]="notification.type === 'default'"
          [class.text-primary-800]="notification.type === 'default'"
          [class.border-primary-200]="notification.type === 'default'"
          [class.bg-success-100]="notification.type === 'success'"
          [class.text-success-800]="notification.type === 'success'"
          [class.border-success-200]="notification.type === 'success'"
          [class.bg-danger-100]="notification.type === 'error'"
          [class.text-danger-800]="notification.type === 'error'"
          [class.border-danger-200]="notification.type === 'error'"
        >
          {{ notification.message }}
        </div>
      }
    </div>
  `
})
export class NotificationComponent {
  constructor(public notificationService: NotificationService) {}
}
